import styled from 'styled-components';

export const ShortcutRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 18px;
`;

export const ShortcutButton = styled.button`
    background: ${({ $active }) =>
        $active ? 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)' : 'transparent'};
    border: 1px solid ${({ $active }) => ($active ? '#f29205' : 'rgba(242, 146, 5, 0.35)')};
    color: ${({ $active }) => ($active ? '#ffffff' : 'rgba(242, 146, 5, 0.8)')};
    padding: 4px 14px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    line-height: 1.5;
    box-shadow: ${({ $active }) => ($active ? '0 2px 10px rgba(242, 146, 5, 0.35)' : 'none')};

    &:hover {
        background: ${({ $active }) =>
            $active ? 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)' : 'rgba(242, 146, 5, 0.12)'};
        border-color: #f29205;
        color: ${({ $active }) => ($active ? '#ffffff' : '#f29205')};
    }

    &:focus {
        outline: none;
    }
`;
